import { useDispatch } from 'react-redux';
import { batchActionDialogActions } from '../../../store/batchActionDialog';
import { RequestConfig } from '../../../services/Main/types.Component';

interface OpenBatchActionDialogProps {
  requestConfig: RequestConfig;
}

export interface UseBatchActionDialogReturnProps {
  openBatchActionDialog: (props: OpenBatchActionDialogProps) => void;
  closeBatchActionDialog: () => void;
}

export const useBatchActionDialog = (): UseBatchActionDialogReturnProps => {
  const dispatch = useDispatch();

  const openBatchActionDialog = ({
    requestConfig,
  }: OpenBatchActionDialogProps) => {
    dispatch(batchActionDialogActions.open({ requestConfig }));
  };

  const closeBatchActionDialog = () => {
    dispatch(batchActionDialogActions.close());
  };

  return {
    openBatchActionDialog,
    closeBatchActionDialog,
  };
};
